import { render, staticRenderFns } from "./Blog.vue?vue&type=template&id=11ed2972&scoped=true"
import script from "./Blog.vue?vue&type=script&lang=ts"
export * from "./Blog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ed2972",
  null
  
)

export default component.exports